import { getEmailDomain } from '../common/emailFormatter';

const prepareRequest = (url) => {
  const xhr = new XMLHttpRequest();

  xhr.timeout = 5000;
  xhr.open('POST', url, true);
  xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');

  return xhr;
};

const createXhrPayload = (jobseekerData) => {
  if (!jobseekerData) {
    return '';
  }

  const payload = ['ConditionAcceptance=on', 'DemAcceptance=true'];
  const lastStatement =
    jobseekerData.statements && jobseekerData.statements.length > 0
      ? jobseekerData.statements[jobseekerData.statements.length - 1]
      : undefined;

  payload.push(`Email=${jobseekerData.email ? encodeURIComponent(jobseekerData.email) : ''}`);
  if (lastStatement) {
    payload.push(`w=${lastStatement.what ? encodeURIComponent(lastStatement.what) : ''}`);
    payload.push(`l=${lastStatement.where ? encodeURIComponent(lastStatement.where) : ''}`);
    payload.push(
      `r=${
        lastStatement.where && lastStatement.radius ? encodeURIComponent(lastStatement.radius) : ''
      }`
    );
  }

  return payload.join('&');
};

const displayErrorMessage = () => {
  document.querySelector('.js-unsubcribe-error-box').removeAttribute('hidden');
};

const displaySuccessMessage = () => {
  document.querySelector('.js-unsubscribe-box').setAttribute('hidden', 'true');
  document.querySelector('.js-remove-page-message').setAttribute('hidden', 'true');
  document.querySelector('.js-unsubcribe-success-box').removeAttribute('hidden');
};

export default function reactivate(unsubscribedJobseekerData) {
  if (!unsubscribedJobseekerData) {
    displayErrorMessage();
    throw new Error(
      `jobseeker data is not available [unsubscribedJobseekerData=${unsubscribedJobseekerData}].`
    );
  }

  const xhr = prepareRequest(`${jrConfigGlobal.baseUrl}jobseeker/create`);
  const xhrPayload = createXhrPayload(unsubscribedJobseekerData);

  xhr.onload = function () {
    if (xhr.status !== 201) {
      displayErrorMessage();
    } else {
      displaySuccessMessage();

      dataLayer.push({
        event: 'unsubscribe.reactivation',
        emailDomain: getEmailDomain(unsubscribedJobseekerData.email),
      });
    }
  };

  xhr.onerror = function () {
    displayErrorMessage();
  };

  xhr.ontimeout = function () {
    displayErrorMessage();
  };

  xhr.send(xhrPayload);
}
